import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Constants } from '../../_utility';
import { BreadcrumbsService } from '../../_components/breadcrumbs/breadcrumbs.service';

@Component({
  selector: 'app-home-ristoranti',
  templateUrl: './home-ristoranti.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [TranslateModule],
})
export class HomeRistorantiComponent implements OnInit {
  constructor(private router: Router, private breadcrumb: BreadcrumbsService) {}

  ngOnInit() {
    setTimeout(() => {
      this.breadcrumb.setCrumbs(Constants.Routing.HOME_RISTORANTI.path);
    }, 200);
  }
  goTo(path: string) {
    switch (path) {
      case 'home': {
        this.router.navigate(Constants.Routing.HOME.routerLink);
        break;
      }
      case 'crea': {
        this.router.navigate(Constants.Routing.NUOVO_RISTORANTE.routerLink);
        break;
      }
      case 'modifica': {
        this.router.navigate(Constants.Routing.MODIFICA_RISTORANTE.routerLink);
        break;
      }
      case 'slot': {
        this.router.navigate(Constants.Routing.GESTIONE_SLOT.routerLink);
        break;
      }
    }
  }
}
